import script from "./ModalQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalQuestions.vue?vue&type=script&setup=true&lang=js"

import "./ModalQuestions.vue?vue&type=style&index=0&id=26098e3a&lang=css"

const __exports__ = script;

export default __exports__